interface IFormatGridTemplateColumns {
    gridColumns: string[];

    isMobile: boolean;
    maxRowWidthMobile: number | undefined;
    maxRowWidthDesktop: number | undefined;
}

export function formatGridTemplateColumns({gridColumns, isMobile, maxRowWidthMobile, maxRowWidthDesktop}: IFormatGridTemplateColumns): string {
    if (isMobile) {
        if (maxRowWidthMobile) {
            return `repeat(${maxRowWidthMobile}, 1fr)`;
        }
    }
    if (maxRowWidthDesktop) {
        return `repeat(${maxRowWidthDesktop}, 1fr)`;
    }

    return `${gridColumns.join(' ')}`;
}
